import type { Monitoring } from '@protector/entities/monitoring/models';
import type { UUID } from '@protector/utils/types';

export const MonitoringActionsTypes = {
  LOAD_AREA_DAY_MONITORING: '[Monitoring] Load Monitoring Info',
  LOAD_AREA_DAY_MONITORING_SUCCESS: '[Monitoring] Load Monitoring Info Success',
  LOAD_AREA_DAY_MONITORING_FAILURE: '[Monitoring] Load Monitoring Info Failure'
} as const;

export const LoadAreaDayMonitoring = (
  propertyId: UUID,
  areaId: UUID,
  day: string,
  showRepresentativeness: boolean,
  representedPointsIds: UUID[],
  areaPointsIds: UUID[]
) => {
  return {
    type: MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING,
    payload: { propertyId, areaId, day, showRepresentativeness, representedPointsIds, areaPointsIds }
  };
};

export const LoadAreaDayMonitoringSuccess = (monitoring: Monitoring[]) => {
  return {
    type: MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING_SUCCESS,
    payload: monitoring
  };
};

export const LoadAreaDayMonitoringFailure = (error: string) => {
  return {
    type: MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING_FAILURE,
    payload: error
  };
};
